import styled, { css } from "styled-components";

import { COLORS } from "@treelab/panda";

export const Container = styled.div``;

export const ContainerMixin = css`
  margin-bottom: 8px;

  .panda-input-dropdown--input {
    height: 32px;
  }

  .panda-dropdown-item--inner-container {
    padding: 0 6px;
  }

  #panda-dropdown-menu {
    margin-top: 0;
    padding: 0;
    font-size: 14px;
    padding-top: 4px;
    padding-bottom: 4px;

    & > panda-dropdown-item--inner-container {
      /* padding-left */
    }
  }
`;

export const IconContainer = styled.div`
  margin-right: 8px;
  display: flex;
  color: ${COLORS.grey};
`;

export const ErrorContainer = styled.div`
  & > :first-child {
    margin-top: 4px
    margin-left: 8px;
    font-size: 12px;
    font-weight: normal;
    line-height: 18px;
    color: ${COLORS.red};
  }
`;

export const Diver = styled.div`
  height: 0px;
  border-bottom: 1px solid ${COLORS.greyLight2};
`;
